import { render, staticRenderFns } from "./CampostTransactions.vue?vue&type=template&id=3dbe578e&scoped=true"
import script from "./CampostTransactions.vue?vue&type=script&lang=js"
export * from "./CampostTransactions.vue?vue&type=script&lang=js"
import style0 from "./CampostTransactions.vue?vue&type=style&index=0&id=3dbe578e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe578e",
  null
  
)

export default component.exports